import * as t from "io-ts"

const Organisation = t.intersection([
    t.type({
        organisationType: t.string,
        recordType: t.string,
        organisationId: t.string,
        organisationName: t.string,
        domains: t.array(t.string),
    }),
    t.partial({
        organisationPostcode: t.string,
        organisationAddress: t.string,
        organisationContactNumber: t.string,
    }),
])

export const GetOrgRes = t.type({
    organisation: Organisation,
})

export type TGetOrgRes = t.TypeOf<typeof GetOrgRes>
